import HttpService from '../services/HttpService';
import decode from 'jwt-decode';
import PollService from '../services/PollService';
import { uniq, find, propEq } from 'ramda';
import { resolveUID } from '../services/StatsService';

const getUser = () => {
  const token = HttpService.getAuthorizationToken();
  let payload;
  try {
    // the jwt-decode lib will throw an error if it can't parse the token
    payload = decode(token);
  } catch (err) {
    // eslint-disable-next-line no-console
    return console.error(`cannot get current user, found token: ${token}. Error: ${err}`);
  }
  return {
    uid: resolveUID(payload),
  };
};

export default {
  state: {
    user: getUser(),
    votesAreLoading: false,
    votes: {}
  },

  getters: {
    userVotes: state => state.votes,
    votesAreLoading: state => state.votesAreLoading,
    userHasVotedAll: (state, getters, rootState) => {
      const pollId = rootState.poll.selectedPollId;
      if (pollId) {
        const questions = getters.questionsOfSelectedPoll;
        const votes = state.votes[pollId] || []
        return questions.length === votes.length && votes.length > 0;  
      }
      return false;
    },
    userScore: (state, getters, rootState) => {
      const userId = state.user.uid;
      const userStat = find(propEq('uid', userId))(rootState.stats.stats.contestStats.perUser) || {};
      return userStat.totalScore;
    },
    totalScore: (state, getters) => {
      const questions = getters.questionsOfSelectedPoll || [];
      return questions.length;
    },
    currentQuestionScore: (state, getters, rootState) => {
      const userId = state.user.id;
      const questionId = rootState.question.selectedQuestionId;
      const questionStat = (rootState.stats.stats.contestStats.perQuestion || []).find(q => q.uid === userId && q.questionId === +questionId);
      return questionStat ? questionStat.score : undefined;
    }
  },

  mutations: {
    SET_VOTES_OF_POLL(state, { pollId, votes }) {
      state.votes = {
        ...state.votes,
        [pollId]: uniq([...(state.votes[pollId] || []), ...votes])
      };
    },

    VOTES_ARE_LOADING(state, areLoading) {
      state.votesAreLoading = areLoading;
    },

    ADD_VOTE(state, { pollId, questionId }) {
      state.votes = {
        ...state.votes,
        [pollId]: [...(state.votes[pollId] || []), questionId]
      };
    }
  },

  actions: {
    // we store votes in the following format:
    // {
    //   pollId: [questionId, ...]
    // }
    fetchUserVotes: ({ commit }, pollId) => {
      commit('VOTES_ARE_LOADING', true);
      PollService.getVotesOfPoll(pollId)
        .then(votes => {
          commit('VOTES_ARE_LOADING', false);
          commit('SET_VOTES_OF_POLL', { pollId, votes });
        })
        .catch(err => {
          commit('VOTES_ARE_LOADING', false);
          throw err;
        });
    },

    saveUserVote: ({ commit }, { pollId, questionId }) => {
      commit('ADD_VOTE', { pollId, questionId });
    }
  }
};
